export default {
  m: 'Male',
  f: 'Female',
  a: 'Ambiguous',
  o: 'Other',
  u: 'Unknown',
};
